import { render, staticRenderFns } from "./PoDetail.vue?vue&type=template&id=32ad1c92&scoped=true&"
import script from "./PoDetail.vue?vue&type=script&lang=js&"
export * from "./PoDetail.vue?vue&type=script&lang=js&"
import style0 from "./PoDetail.vue?vue&type=style&index=0&id=32ad1c92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad1c92",
  null
  
)

export default component.exports